var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('heading',{attrs:{"text":_vm.text,"justify":_vm.justify,"heading":_vm.heading}}),_c('text-paragraph')],1)}
var staticRenderFns = []

export { render, staticRenderFns }